import { PublisherStatusEnum } from "../types/Api";
export var formatPublisherLabel = function (publisher, formatMessage) {
    var _a;
    var nameSuffix = publisher.nameSuffix ? ", ".concat(publisher.nameSuffix) : "";
    var qualifier = publisher.qualifier ? " \u2014 ".concat(publisher.qualifier) : "";
    var municipality = publisher.municipality && publisher.municipality !== publisher.qualifier
        ? " \u2014 ".concat(publisher.municipality)
        : "";
    var activePrefix = publisher.activePrefix
        ? " [".concat(publisher.activePrefix, "]")
        : "";
    var status = publisher.status && publisher.status !== PublisherStatusEnum.ACTIVE
        ? formatMessage
            ? " (".concat(formatMessage({ id: "ui-br-agency.status.".concat(publisher.status) }), ")")
            : " (".concat(publisher.status, ")")
        : "";
    return "".concat((_a = publisher.name) !== null && _a !== void 0 ? _a : "").concat(nameSuffix).concat(qualifier).concat(municipality).concat(activePrefix).concat(status);
};
